import { VerifyEmailData, VerifyEmailVars } from '../gql-types';

import GraphQL from '../gql';
import ProgressMessageBox from './ProgressMessageBox';
import React from 'react';
import User from '../models/User';
import VerifyEmailResult from '../models/VerifyEmailResult';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';

const useQueryParams = () => {
  return new URLSearchParams(useLocation().search);
}
interface VerifyEmailProps {
  onVerify: (result: VerifyEmailResult, user?: User) => void;
}

const VerifyEmail = (props: VerifyEmailProps) => {
  const query = useQueryParams();
  const { loading, error, data } =
    useQuery<VerifyEmailData, VerifyEmailVars>(GraphQL.Query.VERIFY_EMAIL,
      {
        variables: {
          token: query.get('token')
        }
      }
    );

  if (loading) {
    return <ProgressMessageBox message="Verifying your email address..." />
  }
  if (error) {
    props.onVerify(VerifyEmailResult.ERROR);
  }
  if (data) {
    props.onVerify(
      data.verifyEmail === null ?
        VerifyEmailResult.ERROR :
        data.verifyEmail.userkey === -1 ?
          VerifyEmailResult.CODE_EXPIRED :
          VerifyEmailResult.SUCCESS,
      data.verifyEmail
    );
  }

  return null;
}

export default VerifyEmail;
